var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequisitesSmallS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 2.71998H12C12 1.73953 11.2824 0.9422 10.4 0.9422H5.6C4.7176 0.9422 4 1.73953 4 2.71998H2.4C1.0768 2.71998 0 3.91642 0 5.38664V14.2755C0 15.7458 1.0768 16.9422 2.4 16.9422H13.6C14.9232 16.9422 16 15.7458 16 14.2755V5.38664C16 3.91642 14.9232 2.71998 13.6 2.71998ZM10.4 2.71998V4.49776H5.5992V2.71998H10.4ZM14.4 14.2755C14.4 14.7662 14.0408 15.1644 13.6 15.1644H2.4C1.9592 15.1644 1.6 14.7662 1.6 14.2755V5.38664C1.6 4.89598 1.9592 4.49776 2.4 4.49776H4C4 5.4782 4.7176 6.27553 5.6 6.27553H10.4C11.2824 6.27553 12 5.4782 12 4.49776H13.6C14.0408 4.49776 14.4 4.89598 14.4 5.38664V14.2755ZM6.4 8.05331H12.8V9.83109H6.4V8.05331ZM6.4 11.6089H12.8V13.3866H6.4V11.6089ZM3.2 8.05331H4.8V9.83109H3.2V8.05331ZM3.2 11.6089H4.8V13.3866H3.2V11.6089Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequisitesSmallS);
export default __webpack_public_path__ + "static/media/requisites-small-S.bdcb07e5e979925425e9ace97d2cf3b2.svg";
export { ForwardRef as ReactComponent };